export default __webpack_public_path__ + "static/media/inkscape.51c8e44d.svg";